import { Link } from 'react-router-dom';

interface MovieCardProps {
  id: string;
  title: string;
  year: number;
  rating: number;
  image: string;
  quality: string;
  categoryName?: string;
}

export default function MovieCard({ id, title, year, rating, image, quality, categoryName }: MovieCardProps) {
  return (
    <Link
      to={`/movie/${id}`}
      className="group block"
    >
      <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200">
        <img
          src={image}
          alt={`${title} 电影海报`}
          title={`${title} 高清在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>

        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 text-[10px] font-medium bg-primary-500 text-white rounded-md whitespace-nowrap">
            {quality}
          </span>
        </div>

        <div className="absolute top-2 left-2">
          <div className="flex items-center gap-1 bg-black/60 backdrop-blur-sm rounded-md px-2 py-0.5">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-star-fill text-[10px] text-accent-500"></i>
            </div>
            <span className="text-[11px] font-medium text-accent-400">{rating}</span>
          </div>
        </div>

        <div className="absolute inset-x-0 bottom-0 p-3">
          {categoryName && (
            <span className="text-[10px] text-primary-400 font-medium mb-1 block">
              {categoryName}
            </span>
          )}
          <h3 className="text-sm font-medium text-white leading-tight line-clamp-2 group-hover:text-primary-300 transition-colors">
            {title}
          </h3>
          <span className="text-[11px] text-foreground-400 mt-1 block">
            {year}
          </span>
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-white shadow-lg transform group-hover:scale-110 transition-transform duration-300">
            <i className="ri-play-fill text-xl ml-0.5"></i>
          </div>
        </div>
      </div>
    </Link>
  );
}